import { connect } from 'react-redux';
import ThreadListMemberOverlay from './ThreadListMemberOverlay';
import { getInboxes } from 'conversations-inbox-lib/unified-inbox/public/selectors';
const mapDispatchToProps = null;
const mapStateToProps = state => ({
  inboxes: getInboxes(state)
});
const ConnectedThreadListMemberOverlay = connect(mapStateToProps, mapDispatchToProps)(ThreadListMemberOverlay);
export default ConnectedThreadListMemberOverlay;